import { config } from 'app/config';
import { user } from 'services';
import { sections } from './sections';

/**
 * in interface
 * @param {*} item
 * @param {*} parent
 * @returns
 */
export const inInterface = (item, parent) => {
  let result = true;
  if (!parent) {
    const testOk = item.id === 'scheme' ? 'mnemo' : item.id;
    if (user.inInterface(testOk)) {
      result = false;
    }
    return result;
  }

  let prefix = parent.id;
  let suffix = item.id;
  switch (parent.id) {
    default:
    case 'options':
      prefix = 'settings';
      break;
    case 'payments':
      prefix = 'payment_means';
      break;
    case 'reports':
      if (suffix === 'refill') {
        suffix = 'refill_accounts';
      }
      break;
  }

  const test1 = prefix + '_' + suffix;
  const test2 = prefix + '_' + suffix + '_menu';

  if (user.inInterface(test1)) {
    result = false;
  }
  if (result && user.inInterface(test2)) {
    result = false;
  }
  return result;
};

/**
 * check section
 * @param {*} item
 */
const isSectionActive = (item, permissions, parent = null) => {
  if (!permissions) {
    return false;
  }
  const test = item.rule ?? item.id + '.' + (item.type === 'card' ? 'view' : 'list');
  let out = false;

  // rules
  if (test === 'show') {
    // always show
    out = true;
  } else if (test === 'config') {
    out = item.ruleTest(config);
  } else if (test === 'right') {
    out = user.haveRight(item.ruleTest);
  } else if (test === 'subsections') {
    // by subsections
    item.subsections.forEach((el) => {
      if (isSectionActive(el, permissions, item)) {
        out = true;
      }
    });
  } else {
    out = !!permissions[test];
  }

  // if (item.hidden) {
  //   out = false;
  // }

  if (out) {
    out = inInterface(item, parent);
  }

  return out;
};

/**
 * get active sections
 * @param {*} permissions
 * @param {*} sections
 * @param {*} parent
 * @returns
 */
export const getActiveSections = (permissions) => {
  const out = sections.filter((item) => isSectionActive(item, permissions));
  // console.log("🚀 ~ getActiveSections ~ out:", out)

  // if nothing found - set default empty page
  if (!out.length || out[0].id === 'scheme') {
    out.splice(0, 0, { id: 'empty', type: 'card' });
  }

  // check for subsections
  out.forEach((item, idx) => {
    if (item.subsections) {
      out[idx].subsections = item.subsections.filter((el) => isSectionActive(el, permissions, item));
    }
  });

  return out;
};
